// extracted by mini-css-extract-plugin
export default {"outer":"SingleTourChart_outer__zQNNI"};